import React from "react";

const NotifyBadge = ({ notify }: { notify: string }) => {
  return (
    <span className="notify">{notify}</span>
  );
};

export default NotifyBadge;
